var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"55vh","width":"100%"},attrs:{"id":`pieChart${_vm.pieData.id ? _vm.pieData.id : ''}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }